import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const whatsappEmbeddedSignupApi = async (payload = {}, authHeaders = {}) => {
  try {
    const body = {
      operation: payload.operation || 'WA_EMBEDDED_SIGNUP',
      payload: payload.payload || {}
    };
    const res = await apiCallPost(apiPaths.whatsappEmbeddedSignup, body, authHeaders);

    if (res && (res.status === 'success' || res.status === 'SUCCESS' || res.status === true)) {
      return { data: res, status: true, msg: res.msg || 'Embedded signup successful' };
    }
    return { data: res, status: true, msg: 'Signup triggered' };
  } catch (err) {
    return { status: false, errMsg: err.message || 'Embedded signup failed' };
  }
};
